import type { Geolocation } from "."

export const toPosition = (
  latlng: Geolocation.Latlng
): Geolocation.Position => {
  const { lat, lng } = latlng

  return [lat, lng].join(`,`)
}
